import React from 'react';
import styled, { css } from 'styled-components';

const Title = (props) => (
  <h1 {...props}>
    <Inner>{props.children}</Inner>
  </h1>
);

const Inner = styled.span`
  position: relative;
  padding: 0 1rem;

  &:before,
  &:after {
    position: absolute;
    top: 50%;
    content: "";
    height: 1px;
    width: 25vw;
    background-color: ${({ theme }) => theme.grayColor};
  }

  &:before {
    right: 100%;
  }

  &:after {
    left: 100%;
  }
`;

export default styled(Title)`
  ${({ $variant }) => $variant === 'buttons' && css`
    flex-grow: 1;
    text-align: center;
    font-size: 1rem;
    font-weight: 300;
    color: #333;
  `}
`;
